module.exports = __webpack_public_path__ + "img/flavorsblur.10749a07.jpg";